export default "__VITE_ASSET__DddP4X61__"